var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAdviceDarkmode = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1036_1064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8102 5.00007H5.87476V7.40007H19.8102V5.00007Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7458 8.60004H10.52V11H15.7458V8.60004Z",
    fill: "#EB6087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.875 17.5999V8.59985H8.19758V13.9999L10.8685 12.7999H17.4879V8.59985H19.8105V15.1999H11.3331L5.875 17.5999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2945 22.5199L18.359 19.9999H12.2622V16.3999H14.5848V17.5999H18.9396L20.9719 18.6799V8.59985H23.2945V22.5199Z",
    fill: "#EB6087"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1036_1064"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(5.75 5)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAdviceDarkmode);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/advice-darkmode.a78f58da78017dbdaba0ea971f9c3f50.svg";